import { useState, useRef, useEffect, useMemo } from "react";

import moment from "moment-timezone";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import Grid from "@mui/material/Grid";
//Backend access
import { getLiveviewHistoryImages } from 'api/bks';
import PropTypes from "prop-types";

import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { PacmanLoader } from "react-spinners";
import CameraFeed from "nextus/Timelines/CameraTimeline/Feed";
import LiveviewSelects from "nextus/Charts/Selectors/Liveview";

import bksAPI from 'api/bks';
import { useQuery } from "@tanstack/react-query";
import { getCameraHistory } from "api/bks";

function wrapper(content) {
    return (
        <SoftBox p={2}>
            {content}
        </SoftBox>
    )
}

// Images
function CameraTimeline({ uuid }) {

    const [endTime, setEndTime] = useState(moment().unix());
    const [startTime, setStartTime] = useState(moment().subtract(2, 'days').unix());
    const [currentTime, setCurrentTime] = useState(moment().unix());
    const [cameraData, setCameraData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    bksAPI.loadToken(useAuth0());

    const currentCameraImage = useQuery({
        queryKey: ['getCameraFeed', uuid],
        queryFn: async () => {
            return await bksAPI.getCameraFeed(uuid);
        }
    });

    useEffect(() => {
        async function getHistory() {
            var data = await getCameraHistory(uuid, startTime, endTime);
            setCameraData(data);
            setIsLoading(false);
        }
        if (!isNaN(startTime) && !isNaN(endTime)) {
            getHistory();
        }
    }, [startTime, endTime]);


    if (currentCameraImage.isLoading) {
        return wrapper("Loading...");
    }

    if (currentCameraImage.error) {
        return wrapper("Error! " + currentCameraImage.error.message);
    }

    const blob = new Blob([currentCameraImage.data]);
    const current_camera_url = URL.createObjectURL(blob);

    return (
        wrapper(
            <CameraFeed {...{ uuid, currentTime, setCurrentTime, startTime, setStartTime, endTime, setEndTime, cameraData, isLoading, current_camera_url }} />
        )
    );
}

// Typechecking props for the CameraTimeline
CameraTimeline.propTypes = {
    uuid: PropTypes.string
};


export default CameraTimeline;